/* eslint-disable jsx-a11y/iframe-has-title */
import React from "react";
import Contactus from "../../assets/contactus.png";
import UAEFlag from "../../assets/UAE.svg";
import Indiaflag from "../../assets/India.svg";
import OmanFlag from "../../assets/Oman.svg";
import RussiaFlag from "../../assets/Russia.svg";
import Mail from "../../assets/mail.svg";
import Phone from "../../assets/phone.svg";
import Map from "../../assets/Map.svg";
import Icon from "../../assets/icon-1.svg";
import Bgabout from "../../assets/backgroundabout.svg";
import Playstore from "../../assets/icon/googlepay.svg";
import Appstore from "../../assets/icon/appstore.svg";
import QrCode from "../../assets/icon/qrcode.svg";
import ManTarvel from "../../assets/icon/man-traveling.svg";
import Mobile from "../../assets/icon/mobile.png";
import Cloud from "../../assets/icon/could.svg";

function contactus() {
  return (
    <div>
      <div className="sectionbg">
        <div className="container mx-auto p-5 md:p-8 lg:px-15">
          <div className="flex gap-5 flex-col justify-center pb-10 pt-5">
            <h1 className="font-bold text-center font-primary text-[40px] leading-[30px]">
              Contact Us
            </h1>
            <p className="font-primary text-xl text-center font-bold inter">
              Our Global Presence
            </p>
            <div className="flex justify-center items-center">
              <img src={Contactus} alt="fbt-b2b" />
            </div>
          </div>
        </div>
      </div>

      <div className="container mx-auto my-4 p-5 md:p-8 md:my-10 lg:px-15">
        <div className="grid grid-cols-1 lg:grid-cols-3 lg:gap-24">
          <div>
            <h1 className="font-semibold text-3xl mb-5 leading-[48px] md:text-[40px] md:leading-[82px]">
              Our Head Office
            </h1>
            <img src={UAEFlag} alt="fbt-b2b" className="border-2 w-full" />
            <p className="py-5 font-medium text-md leading-[30px] w-full">
              <span className="text-black font-bold">
                Reach at United Arab Emirates
              </span>
              <br />
              <span className="text-sm ">
                <div className="flex gap-2 my-1 items-start text-black">
                  {" "}
                  <img src={Map} alt="Journeyx" />
                  Office No. 400-70,4th Floor, Fahidi Height Office Tower, Bank
                  Street Mankhol Bur Dubai, Dubai-UAE
                </div>
              </span>
              <span className="flex gap-2 my-1 text-black">
                <img src={Mail} alt="Journeyx" />
                <a href="mailto:uae@fbtdmc.com" className="hover">
                  uae@fbtdmc.com
                </a>
              </span>
              <span className="flex gap-2 mb-1 text-black">
                <img src={Phone} alt="Journeyx" />
                <a href="tel:+971-582788055" className="hover">
                  +971-582788055
                </a>
              </span>
            </p>
          </div>
          <div className="col-span-2">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3608.365181459461!2d55.293563680457474!3d25.258298120099518!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f5dca0b66b8cd%3A0x77b6f3e57fa7a69e!2sFBT%20Adventures%20Travels%20LLC!5e0!3m2!1sen!2sin!4v1722246179851!5m2!1sen!2sin"
              width="100%"
              height="450"
              className="border-2"
              allowfullscreen=""
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </div>
      <div
        className="sectionbg"
        style={{
          backgroundImage: `url(${Bgabout})`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "bottom",
        }}
      >
        <div className="container mx-auto p-5 md:p-8 lg:px-15">
          <div>
            <span className="flex gap-2 items-baseline my-1 text-black">
              <img src={Icon} alt="Journeyx" />
              <h2 className="font-primary font-bold text-xl md:text-2xl">
                Our Other Locations
              </h2>
            </span>
            <h1 className="font-semibold mt-5 mb-10 text-2xl md:text-3xl md:mb-24">
            Connect with our dedicated sales team globally
            </h1>
            <div className="grid grid-cols-1 mb-20 gap-6 lg:grid-cols-3 lg:gap-32">
              <div className="pb-5">
                <div>
                  <img
                    src={OmanFlag}
                    alt="fbt-b2b"
                    className="border-2 w-full"
                  />
                </div>
                <p className="pt-0 font-medium text-md leading-[30px] w-full md:pt-5">
                  <span className="text-black font-bold">Reach us at Oman</span>
                  <br />
                  <span className="text-sm ">
                    <div className="flex gap-2 my-1 items-start text-black">
                      {" "}
                      <img src={Map} alt="Journeyx" />
                      Mile Stone Travels & Tour. Ruwi Main Market P O BOX 678 PC
                      131 Opp Old Poilce Station Ruwi, Muscat, Sultanate of Oman
                    </div>
                  </span>
                  <span className="flex gap-2 my-1 text-black">
                    <img src={Mail} alt="Journeyx" />
                    <a href="mailto:oman@fbtdmc.com" className="hover">
                      oman@fbtdmc.com
                    </a>
                  </span>
                  <span className="flex gap-2 mb-1 text-black">
                    <img src={Phone} alt="Journeyx" />
                    <a href="tel:+96879531629" className="hover">
                      +968-7953-1629
                    </a>
                  </span>
                </p>
              </div>
              <div className="pb-5">
                <div>
                  <img src={Indiaflag} alt="fbt-b2b" className="border-2 w-full"/>
                </div>
                <p className="pt-0 font-medium text-md leading-[30px] w-full md:pt-5">
                  <span className="text-black font-bold">
                    Reach us at India
                  </span>
                  <br />
                  <span className="text-sm ">
                    <div className="flex gap-2 my-1 items-start text-black">
                      <img src={Map} alt="Journeyx" />
                      Unit No. 4068 B wings Oberoi Garden Estate Chandivali Farm
                      Road Andheri East Mumbai Maharashtra India
                    </div>
                  </span>
                  <span className="flex gap-2 my-1 text-black">
                    <img src={Mail} alt="Journeyx" />
                    <a href="mailto:info@fbtdmc.com" className="hover">
                    info@fbtdmc.com
                    </a>
                  </span>
                  <span className="flex gap-2 mb-1 text-black">
                    <img src={Phone} alt="Journeyx" />
                    <a href="tel:+919821869339" className="hover">
                     +91-98218-69339
                    </a>
                   
                  </span>
                </p>
              </div>
              <div className="pb-5">
                <div>
                  <img src={RussiaFlag} alt="fbt-b2b" className="border-2 w-full"/>
                </div>
                <p className="pt-0 font-medium text-md leading-[30px] w-full md:pt-5">
                  <span className="text-black font-bold">
                    Reach us at Russia
                  </span>
                  <br />
                  <span className="text-sm ">
                    <div className="flex gap-2 my-1 items-start text-black">
                      <img src={Map} alt="Journeyx" />
                      Russia 129226 Moscow, Str.Selskpkhozaistvennaya - 4 CT. 9
                      office K9 M VDKH.
                    </div>
                  </span>
                  <span className="flex gap-2 my-1 text-black">
                    <img src={Mail} alt="Journeyx" />
                    <a href="mailto:russia@fbtdmc.com" className="hover">
                      russia@fbtdmc.com
                    </a>
                  </span>
                  <span className="flex gap-2 mb-1 text-black">
                    <img src={Phone} alt="Journeyx" />
                    <a href="tel:+79161981826" className="hover">
                      +7 (916) 198-18-26
                    </a>
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="relative my-0 md:my-10">
        <img src={Cloud} alt="fbtb2b" className="absolute top-[5%] left-[50%]" />
        <img src={Cloud} alt="fbtb2b" className="absolute top-[12%] left-[30%]" />
        <img src={Cloud} alt="fbtb2b" className="absolute top-[2%] left-[10%]" />
        <img
          src={Cloud}
          alt="fbtb2b"
          className="absolute top-[5%] left-[80%] hidden md:block"
        />
        <div className="container mx-auto p-5 md:p-8 lg:px-15">
          <div className="py-10 flex flex-col justify-between lg:flex-row">
            <div className="w-full flex flex-col gap-1 lg:w-2/5">
              <div className="font-semibold font-primary text-base mb-3 text-center md:text-left">
                Get all your trip detail in our Mobile App
              </div>
              <div className="font-semibold font-primary text-3xl mb-3 text-center md:text-left">
              <span className="text-[rgb(24,119,242)]">Journey<span className="text-[#e51e25]">X</span></span> the one stop destination for all your trip worries
              </div>
              <div className="flex flex-wrap flex-col items-center justify-center gap-5 my-5 sm:flex-row md:justify-start">
                <div class="hover01 column">
                  <div>
                    <figure>
                      <img
                        src={Appstore}
                        className="max-w-48 w-full"
                        alt="fbt-b2b"
                      />
                    </figure>
                  </div>
                </div>
                <div class="hover01 column">
                  <div>
                    <figure>
                      <img
                        src={Playstore}
                        className="max-w-48 w-full"
                        alt="fbt-b2b"
                      />
                    </figure>
                  </div>
                </div>
              </div>
              <div className="flex flex-col items-center gap-5 my-5 justify-center md:justify-start md:flex-row">
                <img src={QrCode} alt="fbt-b2b" />
                <div className="font-semibold font-primary text-lg mb-3 text-center md:text-left ">
                  Scan the QR code to install JourneyX Mobile App
                </div>
              </div>
            </div>
            <div className="relative flex w-full lg:w-[60%] justify-center pt-10 md:justify-end lg:pt-0">
              <img
                src={ManTarvel}
                alt="fbt-b2b"
                className="absolute z-10 left-[-120px] top-[15%] hidden md:block"
              />
              <div className="relative">
                <img
                  src={Mobile}
                  alt="fbt-b2b"
                  className="max-w-[529px] w-full"
                />
                {/* <img src={Shadow} alt="fbt-b2b" className="absolute bottom-[-20%] left-1/2 transform -translate-x-1/2 -translate-y-1/2 hidden md:block lg:bottom-[-5%]"/> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default contactus;
